module.exports = __webpack_public_path__ + "img/jbt9159_10_1999.prt.1c176b0d.jpg";